var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.37 2.083a3.93 3.93 0 0 1 5.547 5.549l-.139.146L8.571 20.984c-.197.197-.378.383-.577.543l-.206.15q-.263.174-.555.29l-.196.072a3 3 0 0 1-.499.113l-.532.066-3.385.375a1.1 1.1 0 0 1-1.215-1.214l.377-3.385.065-.532c.026-.171.06-.336.113-.498l.071-.198q.117-.292.29-.554l.15-.205c.16-.2.346-.381.544-.579L16.223 2.223zM4.57 16.984c-.162.162-.256.258-.314.32l-.098.119a1 1 0 0 0-.06.105l-.045.113a1 1 0 0 0-.03.15l-.054.446-.225 2.018 2.018-.224.446-.054a1 1 0 0 0 .15-.03l.113-.046a1 1 0 0 0 .105-.06l.118-.098c.062-.058.158-.152.32-.314l9.43-9.43L14 7.556zM20.223 3.778a1.73 1.73 0 0 0-2.314-.12l-.13.12L15.555 6 18 8.444l2.223-2.222.118-.131a1.73 1.73 0 0 0-.118-2.313"
  })));
};
export default SvgEdit;